/**
 * 经典文献管理器
 * 负责动态加载和管理多个经典文献
 */

class ClassicsManager {
  constructor() {
    this.availableClassics = [
      {
        id: 'tao-te-ching',
        title: '道德经',
        author: '老子',
        dataFile: 'api-intTools_LearningPlatform_LP_Datas_Tao-Te-Ching.js',
        globalVar: 'TAO_TE_CHING_DATA'
      }
      // 未来可以添加更多经典：
      // {
      //   id: 'zhuang-zi',
      //   title: '庄子',
      //   author: '庄子',
      //   dataFile: 'LP_Datas_zhuang_zi.js',
      //   globalVar: 'ZHUANG_ZI_DATA'
      // }
    ];
    
    this.loadedClassics = new Map();
    this.currentClassic = null;
  }

  /**
   * 获取可用的经典列表
   */
  getAvailableClassics() {
    return this.availableClassics;
  }

  /**
   * 动态加载经典文献数据
   */
  async loadClassic(classicId) {
    // 如果已经加载过，直接返回
    if (this.loadedClassics.has(classicId)) {
      return this.loadedClassics.get(classicId);
    }

    const classicInfo = this.availableClassics.find(c => c.id === classicId);
    if (!classicInfo) {
      throw new Error(`未找到经典: ${classicId}`);
    }

    try {
      // 动态加载JS文件
      await this.loadScript(classicInfo.dataFile);
      
      // 获取全局变量中的数据
      const data = window[classicInfo.globalVar];
      if (!data) {
        throw new Error(`未找到数据: ${classicInfo.globalVar}`);
      }

      // 缓存数据
      this.loadedClassics.set(classicId, data);
      this.currentClassic = data;
      
      return data;
    } catch (error) {
      console.error(`加载经典失败: ${classicId}`, error);
      throw error;
    }
  }

  /**
   * 动态加载脚本文件
   */
  loadScript(src) {
    return new Promise((resolve, reject) => {
      // 检查是否已经加载过
      const existingScript = document.querySelector(`script[src="${src}"]`);
      if (existingScript) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  /**
   * 注册新的经典文献
   */
  registerClassic(classicInfo) {
    // 检查是否已存在
    const existingIndex = this.availableClassics.findIndex(c => c.id === classicInfo.id);
    if (existingIndex !== -1) {
      // 更新现有的
      this.availableClassics[existingIndex] = classicInfo;
    } else {
      // 添加新的
      this.availableClassics.push(classicInfo);
    }
  }

  /**
   * 获取当前经典的版本列表
   */
  getCurrentVersions() {
    if (!this.currentClassic || !this.currentClassic.classics || !this.currentClassic.classics[0]) {
      return [];
    }
    return this.currentClassic.classics[0].versions || [];
  }

  /**
   * 切换到指定版本
   */
  switchVersion(versionId) {
    const versions = this.getCurrentVersions();
    return versions.find(v => v.id === versionId);
  }

  /**
   * 检查经典是否已加载
   */
  isClassicLoaded(classicId) {
    return this.loadedClassics.has(classicId);
  }

  /**
   * 获取已加载的经典数据
   */
  getLoadedClassic(classicId) {
    return this.loadedClassics.get(classicId);
  }

  /**
   * 自动扫描并注册经典文献（基于文件命名规范）
   * 文件命名规范：LP_Datas_[classic-name].js
   * 全局变量命名规范：[CLASSIC_NAME]_DATA
   */
  autoRegisterClassics() {
    // 这个方法可以在未来扩展，自动检测页面中已加载的数据文件
    // 目前手动维护 availableClassics 数组
    console.log('经典管理器已初始化，当前可用经典:', this.availableClassics.length);
  }

  /**
   * 添加新经典的便捷方法
   * @param {string} id - 经典ID
   * @param {string} title - 经典标题
   * @param {string} author - 作者
   * @param {string} fileName - 文件名（不含扩展名）
   */
  addClassic(id, title, author, fileName) {
    const classicInfo = {
      id: id,
      title: title,
      author: author,
      dataFile: `LP_Datas_${fileName}.js`,
      globalVar: `${fileName.toUpperCase().replace(/-/g, '_')}_DATA`
    };
    this.registerClassic(classicInfo);
    return classicInfo;
  }
}

// 全局实例
window.classicsManager = new ClassicsManager();